import normalize from "jsonapi-normalizer";
import { makeAutoObservable } from "mobx";
import { CreateProfile, DeleteProfile, RestoreProfile, UpdateProfileRelations } from "../../../api/typings/Profiles";
import {
  getDeleteProfileData,
  getRestoreProfileData,
  getCreateProfileData,
  getUpdateProfileRelationsData,
} from "../../serializers/usersProfilesSerializer";
import { ProfilesApi } from "../../../api/users/ProfilesApi";
import { NormalizedResources } from "../../typings/services";

export class ProfileService {
  constructor() {
    makeAutoObservable(this);
  }

  createProfile = async (data: CreateProfile): Promise<NormalizedResources> => {
    const { role, user } = data;
    const createProfileData = await getCreateProfileData(data);
    const profileResponse = await ProfilesApi.createProfile(user.id, createProfileData, {
      include: [
        role,
        "user",
        "user.permissions",
        "admin",
        "assistant",
        "contenter",
        "parent",
        "student",
        "supervisor",
        "tutor",
        "user.permissions",
        "related_as_primary",
        "related_as_secondary",
        "related_as_primary.user",
        "related_as_secondary.user",
      ],
    });
    return normalize(profileResponse).entities;
  };

  deleteProfile = async (
    data: DeleteProfile
  ): Promise<Pick<NormalizedResources, "users" | "permissions" | "users_profiles">> => {
    const deleteProfileData = await getDeleteProfileData(data);
    const response = await ProfilesApi.deleteProfile(data.id, deleteProfileData, {
      include: [
        "user",
        "admin",
        "assistant",
        "contenter",
        "parent",
        "student",
        "supervisor",
        "tutor",
        "user.permissions",
        "related_as_primary",
        "related_as_secondary",
        "related_as_primary.user",
        "related_as_secondary.user",
      ],
      with_trashed: "1",
    });
    return normalize(response).entities;
  };

  restoreProfile = async (
    data: RestoreProfile
  ): Promise<Pick<NormalizedResources, "users" | "permissions" | "users_profiles">> => {
    const restoreProfileData = await getRestoreProfileData(data);
    const response = await ProfilesApi.restoreProfile(data.id, restoreProfileData, {
      include: [
        "user",
        "admin",
        "assistant",
        "contenter",
        "parent",
        "student",
        "supervisor",
        "tutor",
        "user.permissions",
        "related_as_primary",
        "related_as_secondary",
        "related_as_primary.user",
        "related_as_secondary.user",
      ],
    });
    return normalize(response).entities;
  };

  updateProfileRelations = async (
    data: UpdateProfileRelations
  ): Promise<Pick<NormalizedResources, "users_profiles">> => {
    const updateProfileRelationsData = await getUpdateProfileRelationsData(data);
    const response = await ProfilesApi.updateProfileRelations(data.id, updateProfileRelationsData, {
      include: [
        "user",
        "related_as_primary",
        "related_as_secondary",
        "related_as_primary.user",
        "related_as_secondary.user",
        "admin",
        "assistant",
        "contenter",
        "parent",
        "student",
        "supervisor",
        "tutor",
      ],
    });
    return normalize(response).entities;
  };
}
